function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import 'regenerator-runtime/runtime';
import breakpointHelper from 'breakpoint-helper';
var _require = require('../config/silo/tailwind.json'),
  tailwind = _require.tailwind;
var screens = tailwind.theme.screens;
var bph = breakpointHelper(screens);
var breakpointDefaults = {
  isMobile: bph.isMatching('sm', true),
  isTablet: bph.isMatching(['sm', 'lg']),
  isTouch: bph.isMatching('lg', true),
  isDesktop: bph.isMatching('lg'),
  isDesktopXl: bph.isMatching('xl')
};
window.Breakpoint = breakpointDefaults;
export var breakpoint = breakpointDefaults;
var breakpointStatus = function breakpointStatus(e, name) {
  var matches = e.matches;
  var capitalizedName = "".concat(name.charAt(0).toUpperCase()).concat(name.slice(1));
  window.Breakpoint["is".concat(capitalizedName)] = matches;
  breakpoint["is".concat(capitalizedName)] = matches;
  return matches;
};
var isMobile = bph.listen({
  name: 'sm',
  useMax: true,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'mobile');
});
var isTablet = bph.listen({
  name: ['sm', 'lg'],
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'tablet');
});
var isTouch = bph.listen({
  name: 'lg',
  useMax: true,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'touch');
});
var isDesktop = bph.listen({
  name: 'lg',
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'desktop');
});
var isDesktopXl = bph.listen({
  name: 'xl',
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'desktopXl');
});
export var BreakpointHelper = _objectSpread(_objectSpread({}, bph), {}, {
  isMobile: isMobile,
  isTablet: isTablet,
  isTouch: isTouch,
  isDesktop: isDesktop,
  isDesktopXl: isDesktopXl
});
window.BreakpointHelper = BreakpointHelper;